module.exports = __webpack_public_path__ + "img/map-marker-icon.d933c0e1.svg";